import { motion } from 'framer-motion'
import { ArrowDown } from 'lucide-react'
import { totalLojas, totalBonus, totalDestinos } from '../data'

const hoje = new Date().toLocaleDateString('pt-BR', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
})

export function Hero() {
  return (
    <section id="top" className="relative pt-28 md:pt-40 pb-20 md:pb-28 bg-gradient-to-b from-bone to-cream overflow-hidden">
      <div className="container-editorial relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="inline-flex items-center gap-3 mb-8"
        >
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-terracotta opacity-60"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-terracotta"></span>
          </span>
          <span className="text-xs tracking-[0.35em] uppercase text-terracotta font-medium">
            Atualizado hoje
          </span>
          <span className="text-xs text-taupe">· {hoje}</span>
        </motion.div>

        <div className="grid md:grid-cols-[1.3fr_1fr] gap-10 md:gap-16 items-end">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
            className="font-display font-light text-4xl md:text-6xl lg:text-[4.5rem] leading-[1.02] tracking-tighter text-ink max-w-4xl"
          >
            O melhor de <em className="text-taupe-dark">pontos e milhas</em>,
            <br className="hidden md:block" /> curado todo dia.
          </motion.h1>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.35 }}
            className="text-base md:text-lg leading-relaxed text-ink/65 md:pb-3"
          >
            <p>
              As lojas que estão pagando mais pontos agora.
              Os bônus de transferência ativos no momento.
              Filtrado por categoria. Ordenado por urgência.
            </p>
            <p className="mt-4 text-sm text-taupe">
              Sem firula. Sem perder tempo.
            </p>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.6 }}
          className="mt-12 md:mt-16 flex flex-wrap items-center gap-3 text-sm"
        >
          <a href="#destinos" className="btn-primary">
            <ArrowDown className="w-3.5 h-3.5" />
            Top 10 destinos executiva
          </a>
          <a href="#compras" className="btn-ghost">
            Top 10 compras
          </a>
          <a href="#milhas" className="inline-flex items-center gap-2 text-ink/70 hover:text-ink px-5 py-3 transition-colors">
            Melhores milhas →
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.8 }}
          className="mt-16 md:mt-20 grid grid-cols-3 gap-4 md:gap-8 max-w-2xl pt-8 border-t border-taupe/20"
        >
          <Stat value={totalDestinos} label="destinos em executiva" />
          <Stat value={totalLojas} label="lojas ativas agora" />
          <Stat value={totalBonus} label="bônus de milhas ativos" />
        </motion.div>
      </div>
    </section>
  )
}

function Stat({ value, label }: { value: number; label: string }) {
  return (
    <div>
      <div className="font-sans font-light text-3xl md:text-5xl text-ink leading-none tracking-tighter tabular-nums">
        {value}
      </div>
      <div className="mt-2 text-xs md:text-[11px] tracking-wider uppercase text-taupe-dark leading-snug max-w-[12ch]">
        {label}
      </div>
    </div>
  )
}
